<script setup lang="ts">
withDefaults(defineProps<{
  id?: string | boolean
  name: string | boolean
  autoplay?: boolean
  loop?: boolean
  speed?: number
  style?: Record<string, string | number>

  width?: number
  height?: number
}>(), {
  id: '',
  loop: false,
  autoplay: true,
  name: '',
  speed: 1,
})

const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const lottie = ref<HTMLElement | null>(null)

defineExpose({
  lottie,
})
</script>

<template>
  <div class="lottie-item" :class="name">
    <lottie-player
      :id="id"
      ref="lottie"
      :class="name" :src="`/lottie/${name}.json`" background="transparent" :speed="speed" :autoplay="autoplay"
      :loop="loop" :style="typeof style === 'object' && style !== null ? style : {}"
    />
  </div>
</template>

<style lang="scss">
.lottie-item {
  // &.rocket {
  //   transform: translateY(-20%);
  //   width: 300px;
  //   height: 300px;
  // }
}
</style>
